module.exports = __webpack_public_path__ + "img/file-earmark-code-fill.d8d4be0d.svg";